import React, {useState} from 'react';
import { Box, Container, Typography, Card, CardContent, CardMedia } from '@mui/material';
import Popper, { PopperPlacementType } from '@mui/material/Popper';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import productCatalog from "../../utils/productCatalog";
import {useNavigate} from "react-router-dom";

const categories = [
  {
    id: 'office',
    name: 'Office',
    description: 'Professional furniture solutions for modern workspaces',
    image: '/images/categories/office.jpg',
    items: ['Filling Cabinet', 'Office Desk', 'Office Chair', 'Meeting Table']
  },
  {
    id: 'hospital',
    name: 'Hospital',
    description: 'Specialized furniture for healthcare facilities',
    image: '/images/categories/hospital.jpg',
    items: ['Hospital Bed', 'Medical Cabinet', 'Treatment Chair', 'Medical Trolley']
  },
  {
    id: 'workshop',
    name: 'Workshop',
    description: 'Durable furniture for industrial environments',
    image: '/images/categories/workshop.jpg',
    items: ['Work Bench', 'Tool Cabinet', 'Industrial Chair', 'Storage System']
  },
  {
    id: 'school',
    name: 'School',
    description: 'Educational furniture for learning spaces',
    image: '/images/categories/school.jpg',
    items: ['Student Desk', 'School Chair', 'Teacher Desk', 'Library Shelf']
  }
];

function ProductSlider() {
  const navigate = useNavigate();

  const [ anchorEl, setAnchorEl ] = useState(null);
  const [ data, setData ] = useState([])

  const open = Boolean(anchorEl);

  return (
    <Box sx={{ py: 8, bgcolor: '#ffffff' }}>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        slotProps={{
          list: {
            'aria-labelledby': 'basic-button',
          },
        }}
      >
        {data.map((item, index) =>
          <MenuItem key={index} onClick={() => navigate(item.path)}>{item.label}</MenuItem>
        )}
      </Menu>
      {/*<Popper*/}
      {/*  open={open}*/}
      {/*  anchorEl={anchorEl}*/}
      {/*  placement={"right-start"}*/}
      {/*  transition*/}
      {/*>*/}
      {/*  {({ TransitionProps }) => (*/}
      {/*    <Fade {...TransitionProps} timeout={350}>*/}
      {/*      <Paper elevation={8} sx={{ p: "15px" }}>*/}
      {/*        {data.map((item, index) => (*/}
      {/*          <Box*/}
      {/*            key={index}*/}
      {/*            sx={{ display: "flex", alignItems: "center", mb: 1 }}*/}
      {/*          >*/}
      {/*            <Typography*/}
      {/*              sx={{*/}
      {/*                // color: '#2c3e50',*/}
      {/*                fontSize: '0.875rem',*/}
      {/*                cursor: "pointer",*/}
      {/*                pr: "15px",*/}
      {/*              }}*/}
      {/*            >*/}
      {/*              {item.label}*/}
      {/*            </Typography>*/}
      {/*          </Box>*/}
      {/*        ))}*/}
      {/*      </Paper>*/}
      {/*    </Fade>*/}
      {/*  )}*/}
      {/*</Popper>*/}
      <Container maxWidth="lg">
        <Typography
          component="h2"
          variant="h3"
          align="center"
          sx={{
            mb: 6,
            color: '#1a1a1a',
            fontWeight: 600,
            '&:after': {
              content: '""',
              display: 'block',
              width: '60px',
              height: '4px',
              background: 'linear-gradient(90deg, #FFD700 0%, #FFA500 100%)',
              margin: '20px auto 0',
              borderRadius: '2px',
            }
          }}
        >
          Our Product Categories
        </Typography>

        <Box
          sx={{
            display: 'grid',
            mx: "100px",
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(2, 1fr)',
            },
            gap: 3,
          }}
        >
          {productCatalog.map((category) => (
            <Card
              key={category.label}
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: '16px',
                overflow: 'hidden',
                boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                transition: 'all 0.3s ease-in-out',
                // '&:hover': {
                //   transform: 'translateY(-8px)',
                //   boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
                //   '& .MuiCardMedia-root': {
                //     transform: 'scale(1.05)',
                //   }
                // }
              }}
            >
              <CardMedia
                component="img"
                // height="200"
                image={category.image}
                alt={category.label}
                sx={{
                  transition: 'transform 0.3s ease-in-out',
                }}
              />
              <CardContent sx={{ flexGrow: 1, p: 3 }}>
                <Typography
                  gutterBottom
                  variant="h5"
                  component="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#FFD700',
                    mb: 2
                  }}
                >
                  {category.label}
                </Typography>
                {/*<Typography*/}
                {/*  variant="body2"*/}
                {/*  color="text.secondary"*/}
                {/*  sx={{ mb: 2 }}*/}
                {/*>*/}
                {/*  {category.description}*/}
                {/*</Typography>*/}
                <Box
                  sx={{
                    listStyle: 'none',
                    p: 0,
                    m: 0,
                  }}
                >
                  {category.subCategories.map((item, index) => (
                    <Box
                      sx={{ display: "flex", alignItems: "center", mb: 1 }}
                    >
                      <ChevronRightIcon />
                      <Typography
                        key={index}
                        onClick={(event) => {
                          setAnchorEl(event.currentTarget);
                          setData(item.subCategories)
                        }}
                        sx={{
                          // color: '#2c3e50',
                          fontSize: '0.875rem',
                          cursor: "pointer",
                          pr: "15px",
                        }}
                      >
                        {item.label}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Container>
    </Box>
  );
}

export default ProductSlider;
